import { api } from '@/lib/api';
import type {
  PharmacyProduct,
  CreateProductInput,
  LinkCatalogProductInput,
  UpdateProductInput,
} from './types';
import type { ProductVariant, CreateVariantInput, UpdateVariantInput } from '@/features/product-variant/types';

// ---- Vendor management ----
export async function fetch_my_products(): Promise<PharmacyProduct[]> {
  const res = await api.get<PharmacyProduct[]>('/vendor/pharmacy/products');
  return res.data;
}

export async function create_product(input: CreateProductInput): Promise<PharmacyProduct> {
  const res = await api.post<PharmacyProduct>('/vendor/pharmacy/products', input);
  return res.data;
}

/** Same endpoint as a custom product — the link is what the body carries. */
export async function link_catalog_product(input: LinkCatalogProductInput): Promise<PharmacyProduct> {
  const res = await api.post<PharmacyProduct>('/vendor/pharmacy/products', input);
  return res.data;
}

export async function update_product(id: string, input: UpdateProductInput): Promise<PharmacyProduct> {
  const res = await api.patch<PharmacyProduct>(`/vendor/pharmacy/products/${id}`, input);
  return res.data;
}

export async function delete_product(id: string): Promise<void> {
  await api.delete(`/vendor/pharmacy/products/${id}`);
}

// ---- Variants ----
export async function create_variant(product_id: string, input: CreateVariantInput): Promise<ProductVariant> {
  const res = await api.post<ProductVariant>(`/vendor/pharmacy/products/${product_id}/variants`, input);
  return res.data;
}

export async function update_variant(variant_id: string, input: UpdateVariantInput): Promise<ProductVariant> {
  const res = await api.patch<ProductVariant>(`/vendor/pharmacy/products/variants/${variant_id}`, input);
  return res.data;
}

export async function delete_variant(variant_id: string): Promise<void> {
  await api.delete(`/vendor/pharmacy/products/variants/${variant_id}`);
}

// ---- Public ----
export async function fetch_public_pharmacy_products(vendor_id: string): Promise<PharmacyProduct[]> {
  const res = await api.get<PharmacyProduct[]>(`/user/vendors/${vendor_id}/pharmacy/products`);
  return res.data;
}
